<template>
<div id="header">
    <div id="pc_nav" :class="{'black' : isColorBlack === true}">    
        <div class="container">
            <router-link tag="a" to="" class="back" id="back">back</router-link>
            <router-link tag="a" to="/" class="logo" id="logo">artube</router-link>
            <ul class="nav_menu">
                <router-link tag="li" to="/Artubeleague" class="artube-league" id="artube-league">아튜브리그</router-link>
                <!-- <router-link tag="li" to="/Swap" class="easy_swap">ATT 간편스왑</router-link> -->
                <li class="easy_swap"><a href="/Swap" target="_blank">ATT 간편스왑</a></li>
                <li class="token_info"><a href="https://scope.klaytn.com/token/0x07aa7ae19b17579f7237ad72c616fecf4ccc787b?tabId=tokenTransfer" target="_blank">Token Info</a></li>
                <router-link tag="li" to="/Charge" class="point" v-if="$store.state.loginCheck">{{$store.state.pgPoint + $store.state.pgBounsPoint + $store.state.attPoint + $store.state.attBounsPoint | comma}} P</router-link>
                <div class="btn-adult" @click="toggleAdult" id="toggle-adult" v-if="$store.state.loginCheck">
                    <img src='../assets/images/btn_19_on.png' v-if="isCheckedAdult" />
                    <img src='../assets/images/btn_19_off.png' v-else />
                </div>
                <li class="search-box" id="search-box">
                    <div class="search-area">
                        <input id="inputSearch" placeholder ="작품/작가명을 검색해주세요" v-model="searchText" @keyup.enter="toggleSearch">
                        <p class="search_icon" id="btnSearch" @click="toggleSearch">search</p>
                    </div>
                    <div class="mobile-search-area">
                        <input id="inputSearch2" placeholder ="작품/작가명을 검색해주세요" v-model="searchText" @keyup.enter="toggleSearch">
                        <img src="../assets/images/icon_clear_mini.svg" v-if="searchText.length > 0"  class="clear_icon" id="btnClear" @click="searchText = ''"/>
                        <p class="search_icon" :class="[searchText.length > 0 ? 'black' : '']" id="btnSearch2" @click="toggleSearch">search</p>
                    </div>
                </li>
                <!-- <li class="search" id="search" @click="searchOp" v-else>
                    <p class="search_icon" @click="toggleSearch">search</p>
                    <div class="search_box" v-if="isOpenSearch">
                        <div class="typingline">
                            <input placeholder="작품/작가명을 검색해주세요">
                            <img src="../assets/images/search_icon.svg" alt="search">
                        </div>
                        <div class="remember">
                            <p>공작새 한마리</p>
                            <img src="../assets/images/icon_search_delete.svg" alt="delete">
                        </div>
                        <p class="no_search">최근 검색어가 없습니다.</p>
                    </div>
                </li> -->
                <li class="hamburger" v-if="$store.state.loginCheck">
                    <button id="toggle" class="btn_nav" @click="showMenu"></button>
                </li>
                <!-- <router-link tag="li" to="/Alarm" class="alarm" v-if="$store.state.loginCheck"></router-link> -->
                <li v-if="!$store.state.loginCheck" class="login" @click="showLoginPopup">
                    <a>Login</a>
                </li>
                <li class="mypage" v-if="$store.state.loginCheck">
                    <img src="../assets/images/img_profile_default.svg" class="mypage_icon" @click="toggleMypage" v-if="$store.state.photo === '' || $store.state.photo === null || siteConfig === null" />
                    <img :src="siteConfig.cdnUrl + '/KR/profilepicture/'+ $store.state.photo" class="mypage_icon" @click="toggleMypage" v-else/>
                    <!-- <p class="mypage_icon" @click="toggleMypage">mypage</p> -->
                    <div class="mypage_box" v-if="isOpenMypage">
                        <div class="box_top">
                            <p class="close" @click="closeMypage">x</p>
                            <div class="profile_box">
                                <img src="../assets/images/img_profile_default.svg" alt="profile photo" v-if="$store.state.photo === '' || $store.state.photo === null || siteConfig === null" >
                                <img :src="siteConfig.cdnUrl + '/KR/profilepicture/'+ $store.state.photo" v-else />
                                <div class="info">
                                    <p class="name">{{$store.state.nickName}}</p>
                                    <p class="email">{{$store.state.email}}</p>
                                    <div class="meta_box" v-if="$store.state.isEnableKaikas && $store.state.erc20Address !== null && $store.state.erc20Address !== '' && $store.state.erc20Address === $store.state.account">
                                        <p>{{($store.state.erc20Address).toString().substr(0,10)}}......{{($store.state.erc20Address).toString().substr(-6)}}</p>
                                        <img src="../assets/images/paper.svg" class="paper" v-clipboard:copy="$store.state.erc20Address" v-clipboard:success="clipboardSuccessHandler"/>
                                    </div>
                                </div>
                            </div>
                            <div class="artpoint_box">
                                <p>아트포인트</p>
                                <p class="artpoint">{{$store.state.pgPoint | comma}}</p>
                            </div>
                            <div class="bonus_point_box">
                                <p>보너스 아트포인트</p>
                                <p class="bonus_point">{{$store.state.pgBounsPoint | comma}}</p>
                            </div>
                            <router-link tag="div" to="/Charge" class="button">아트포인트 충전</router-link>
                        </div>
                        <div class="box_bottom">
                            <ul>
                                <router-link tag="li" to="/Changeinfo">
                                    내 정보
                                </router-link>
                                <router-link tag="li" to="/Mybookroom">
                                    내 서재
                                </router-link>
                                <router-link tag="li" to="/Notice">
                                    공지사항
                                </router-link>
                                <router-link tag="li" to="/FAQ">
                                    자주하는 질문
                                </router-link>
                                <router-link tag="li" to="/Contact">
                                    1:1 문의하기
                                </router-link>
                                <router-link tag="li" to="/LeagueMypage">
                                    내 작품
                                </router-link>
                                <li @click="showJeanGuidePopup">
                                    연재문의
                                </li>
                                <li @click="logout">
                                    로그아웃
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li class="metamask" id="nav_metamask" v-if="$store.state.loginCheck">
                    <div class="connect-wallet address" @click="toggleKaikas" v-if="$store.state.isEnableKaikas && $store.state.erc20Address !== null && $store.state.erc20Address !== '' && $store.state.erc20Address === $store.state.account">
                        <img src="../assets/images/icon_wallet_lock.svg" class="icon lock" />
                        <span>{{$store.state.erc20Address}}</span>
                        <img src="../assets/images/icon_wallet_arrow.svg" class="icon arrow" />
                    </div>
                    <div class="connect-wallet connect" @click="toggleKaikas" v-else>
                        <img src="../assets/images/icon_wallet.svg" class="icon wallet" />
                        <span>지갑 연결</span>
                    </div>
                    
                    <div class="metamask_box" v-if="isOpenKaikas">
                        <div class="box_top">
                            <p class="close" @click="closeKaikas">x</p>
                            <div class="profile_box">
                                <img src="../assets/images/img_profile_default.svg" alt="profile photo" v-if="$store.state.photo === '' || $store.state.photo === null || siteConfig === null" >
                                <img :src="siteConfig.cdnUrl + '/KR/profilepicture/'+ $store.state.photo" v-else />
                            <div class="info">
                                <p class="name">{{$store.state.nickName}}</p>
                                <p class="email">{{$store.state.email}}</p>
                            </div>
                            </div>
                        </div>
                        <div class="box_bottom">
                            <p>보유 코인</p>
                            <p>{{$store.state.attTokenBalance | comma}} ATT</p>
                            <router-link tag="div" to="/Charge/ATT" class="button">아트포인트로 충전</router-link>
                            <div class="ad_box">
                                <div class="ad_top">
                                    <p>내 지갑 주소</p>
                                    <img src="../assets/images/paper.svg" v-clipboard:copy="$store.state.erc20Address" v-clipboard:success="clipboardSuccessHandler"/>
                                </div>
                                <p class="ad">{{$store.state.erc20Address}}</p>
                            </div>
                        </div>
                    </div>
                </li>
                <!-- <li class="metamask" id="nav_metamask" v-if="$store.state.loginCheck">
                    <div class="connect-wallet address" @click="toggleMetamask" v-if="$store.state.isEnableMetamask && $store.state.erc20Address !== null && $store.state.erc20Address !== '' && $store.state.erc20Address === $store.state.account">
                        <img src="../assets/images/icon_wallet_lock.svg" class="icon lock" />
                        <span>{{$store.state.erc20Address}}</span>
                        <img src="../assets/images/icon_wallet_arrow.svg" class="icon arrow" />
                    </div>
                    <div class="connect-wallet connect" @click="toggleMetamask" v-else>
                        <img src="../assets/images/icon_wallet.svg" class="icon wallet" />
                        <span>지갑 연결</span>
                    </div>
                    
                    <div class="metamask_box" v-if="isOpenMetamask">
                        <div class="box_top">
                            <p class="close" @click="closeMetamask">x</p>
                            <div class="profile_box">
                                <img src="../assets/images/img_profile_default.svg" alt="profile photo" v-if="$store.state.photo === '' || $store.state.photo === null || siteConfig === null" >
                                <img :src="siteConfig.cdnUrl + '/KR/profilepicture/'+ $store.state.photo" v-else />
                            <div class="info">
                                <p class="name">{{$store.state.nickName}}</p>
                                <p class="email">{{$store.state.email}}</p>
                            </div>
                            </div>
                        </div>
                        <div class="box_bottom">
                            <p>보유 코인</p>
                            <p>{{$store.state.attTokenBalance | comma}} ATT</p>
                            <router-link tag="div" to="/Charge/ATT" class="button">아트포인트로 충전</router-link>
                            <div class="ad_box">
                                <div class="ad_top">
                                    <p>내 지갑 주소</p>
                                    <img src="../assets/images/paper.svg" v-clipboard:copy="$store.state.erc20Address" v-clipboard:success="clipboardSuccessHandler"/>
                                </div>
                                <p class="ad">{{$store.state.erc20Address}}</p>
                            </div>
                        </div>
                    </div>
                </li> -->
            </ul>
        </div>
        <div class="overlay" id="overlay" :class="is_show_overlay ? 'show' : '' "></div>
        <!--  v-if="isOpenMypage" -->
        <li class="mypage" id="m_mypage">
            <p class="title">메뉴</p>
            <div class="info">
                <img src="../assets/images/img_profile_default.svg" alt="profile photo" v-if="$store.state.photo === '' || $store.state.photo === null || siteConfig === null" >
                <img :src="siteConfig.cdnUrl + '/KR/profilepicture/'+ $store.state.photo" v-else />
                <div class="info_inner">
                    <p>{{$store.state.nickName}}</p>
                    <p>{{$store.state.email}}</p>
                    <div class="meta_box" v-if="$store.state.isEnableKaikas && $store.state.erc20Address !== null && $store.state.erc20Address !== '' && $store.state.erc20Address === $store.state.account">
                        <p>{{($store.state.erc20Address).toString().substr(0,10)}}......{{($store.state.erc20Address).toString().substr(-6)}}</p>
                        <img src="../assets/images/paper.svg" class="paper" v-clipboard:copy="$store.state.erc20Address" v-clipboard:success="clipboardSuccessHandler"/>
                    </div>
                    <router-link tag="a" to="/Charge">아트포인트 충전</router-link>
                </div>
            </div>
            <div class="point">
                <div class="point_inner">
                    <p>아트포인트</p>
                    <p>{{$store.state.pgPoint | comma}}</p>
                </div>
                <div class="point_inner">
                    <p>보너스 아트포인트</p>
                    <p>{{$store.state.pgBounsPoint | comma}}</p>
                </div>
            </div>
            <div class="point">
                <div class="point_inner">
                    <a href="/Swap" target="_blank">ATT 간편스왑</a>
                </div>
                <div class="point_inner">
                    <a href="https://scope.klaytn.com/token/0x07aa7ae19b17579f7237ad72c616fecf4ccc787b?tabId=tokenTransfer" target="_blank" class="sub_token_info">Token Info</a>
                </div>
            </div>
            
            <ul class="site_menu">
                <li>
                    <router-link tag="div" to="/ChangeInfo" class="menuIcon">
                        <img src="../assets/images/mobile/icon_user.svg" alt="아이콘">
                        <p>내 정보</p>
                        <span class="direct"></span>
                    </router-link>
                </li>
                <!-- <li>
                    <router-link tag="div" to="/" class="menuIcon">
                        <img src="../assets/images/mobile/icon_wallet.svg" alt="아이콘">
                        <p>내 지갑</p>
                        <span class="direct"> </span>
                    </router-link>
                </li> -->
                <li>
                    <router-link tag="div" to="/Mybookroom" class="menuIcon">
                        <img src="../assets/images/mobile/icon_book.svg" alt="아이콘">
                        <p>내 서재</p>
                        <span class="direct"> </span>
                    </router-link>
                </li>
                <li>
                    <router-link tag="div" to="/Notice" class="menuIcon">
                        <img src="../assets/images/mobile/icon_notice.svg" alt="아이콘">
                        <p>공지사항</p>
                        <span class="direct"> </span>
                    </router-link>
                </li>
                <li>
                    <router-link tag="div" to="/FAQ" class="menuIcon">
                        <img src="../assets/images/mobile/icon_question.svg" alt="아이콘">
                        <p>자주하는 질문</p>
                        <span class="direct"> </span>
                    </router-link>
                </li>
                <li>
                    <router-link tag="div" to="/Contact" class="menuIcon">
                        <img src="../assets/images/mobile/icon_contact.svg" alt="아이콘">
                        <p>1:1 문의하기</p>
                        <span class="direct"> </span>
                    </router-link>
                </li>
                <li>
                    <div v-b-toggle.collapse-1 class="menuIcon">
                        <img src="../assets/images/mobile/icon_attpoint.svg" alt="아이콘">
                        <p>아트포인트</p>
                        <span class="bg_more"> </span>
                    </div>
                    <b-collapse id="collapse-1" tag="ul">
                        <router-link tag="li" class="menuIcon" to="/Charge">- 충전</router-link>
                        <router-link tag="li" class="menuIcon" to="/ChargeHistory">- 충전내역</router-link>
                        <router-link tag="li" class="menuIcon" to="/Withdraw">- 출금</router-link>
                        <router-link tag="li" class="menuIcon" to="/WithdrawHistory">- 출금내역</router-link>
                        <router-link tag="li" class="menuIcon" to="/UseHistory">- 사용내역</router-link>
                        <!-- <router-link tag="li" class="menuIcon" to="/m/BonusGuide">보너스 판정 가이드</router-link> -->
                    </b-collapse>
                </li>
            </ul>

            <!-- <ul class="menu">
                <router-link tag="li" to="/Changeinfo">
                    <img src="../assets/images/mobile/icon_user.svg" alt="아이콘">
                    <p>내 정보</p>
                    <img src="../assets/images/mobile/icon_right_arrow.svg" alt="화살표">
                </router-link>
                <router-link tag="li" to="Mybookroom">
                    <img src="../assets/images/mobile/icon_book.svg" alt="아이콘">
                    <p>내 서재</p>
                    <img src="../assets/images/mobile/icon_right_arrow.svg" alt="화살표">
                </router-link>
                <router-link tag="li" to="Alarm">
                    <img src="../assets/images/mobile/icon_bell.svg" alt="아이콘">
                    <p>알림함</p>
                    <img src="../assets/images/mobile/icon_right_arrow.svg" alt="화살표">
                </router-link>
                <router-link tag="li" to="Notice">
                    <img src="../assets/images/mobile/icon_notice.svg" alt="아이콘">
                    <p>공지사항</p>
                    <img src="../assets/images/mobile/icon_right_arrow.svg" alt="화살표">
                </router-link>
                <router-link tag="li" to="FAQ">
                    <img src="../assets/images/mobile/icon_question.svg" alt="아이콘">
                    <p>자주하는 질문</p>
                    <img src="../assets/images/mobile/icon_right_arrow.svg" alt="화살표">
                </router-link>
                <router-link tag="li" to="Contact">
                    <img src="../assets/images/mobile/icon_contact.svg" alt="아이콘">
                    <p>1:1 문의하기</p>
                    <img src="../assets/images/mobile/icon_right_arrow.svg" alt="화살표">
                </router-link>
                <li @click="showJeanGuidePopup">
                    <img src="../assets/images/mobile/icon_serial.svg" alt="아이콘">
                    <p>연재문의</p>
                    <img src="../assets/images/mobile/icon_right_arrow.svg" alt="화살표">
                </li>
                <router-link tag="li" to="">
                    <img src="../assets/images/mobile/icon_setting.svg" alt="아이콘">
                    <p>설정</p>
                    <img src="../assets/images/mobile/icon_right_arrow.svg" alt="화살표">
                </router-link>
            </ul> -->
            <!-- <img src="../assets/images/mobile/ad.webp" alt="광고"> -->
            <img src="../assets/images/advertising1.png" />
            <a @click="logout">로그아웃</a>
        </li>

    </div>
    <Login :initIsShowPopup="isShowLoginPopup" @loginComplete="loginComplete" @close="close('Login')" />
    <Jeanguide :initIsShowPopup="isShowJeanguidePopup" @close="close('JeanGuide')" />
    <!-- <AdultConfirm  :initIsShowPopup="isShowAdultConfirmPopup" @close="close('AdultConfirm')" /> -->
    <!-- <Metamask :initIsShowPopup="isShowMetamaskPopup" :initRunInterval="initMetamaskRunInterval" @close="close('Metamask')" /> -->
    <Kaikas :initIsShowPopup="isShowKaikasPopup" :initRunInterval="initKaikasRunInterval" :initIsMainNetForce="initIsMainNetForce" @close="close('Kaikas')" />
    <PopupOK :initIsShowPopup="isShowPopupOkPopup" :initPopupOkMessage="initPopupOkMessage" @close="close('PopupOk')" />
</div>
</template>

<script>

import Login from '@/components/Login.vue'
import Jeanguide from '@/components/Jeanguide.vue'
// import AdultConfirm from '@/components/Adultconfirm.vue'
// import Metamask from '@/components/PopupMetamask.vue'
import Kaikas from '@/components/PopupKaikas.vue'
import PopupOK from '@/components/PopupOK.vue'

export default {
    name: 'Header',
    components: {
        Login,
        Jeanguide,
        // AdultConfirm,
        // Metamask,
        Kaikas,
        PopupOK,
    },
    
    data() {
        return {
            
            searchText: '',

            isCheckedAdult: false,
            isOpenSearch: false,
            isOpenMypage: false,
            isOpenMetamask: false,
            isOpenKaikas: false,
            isShowLoginPopup: false,
            isShowJeanguidePopup: false,
            isShowAdultConfirmPopup: false,
            isShowMetamaskPopup: false,
            isShowKaikasPopup: false,

            isColorBlack : this.initIsColorBlack,

            width_size : window.outerWidth,
			is_on_sideMenu : false,
			is_show_sideMenu : false,
			is_show_overlay: false,

            initMetamaskRunInterval: true,
            initKaikasRunInterval: true,
            initIsMainNetForce: false,      //메인넷으로 고정할지 여부

            isShowPopupOkPopup: false,
            initPopupOkMessage: '',
            PopupOkCallbakPage: '',    // 확인 팝업에서 확인 버튼 눌렀을때 이동할 페이지
        }
    },
    props: {
        initIsColorBlack: {
            type: Boolean,
            default: true
        }
    },
    async created() {
        var that = this;

        window.removeEventListener('mouseup', (e) =>{ this.handleMouseUp(e);});

        if(this.isColorBlack === false){
            window.addEventListener('scroll',this.handleScroll, false);
        }
        window.addEventListener('resize', this.handleResize, false);
        window.addEventListener('mouseup', (e) =>{ e.preventDefault();  this.handleMouseUp(e);}, false);

        if (window.addEventListener) {
            window.addEventListener("message", that.onMessage, false);
        }
        else if (window.attachEvent) {
            window.attachEvent("onmessage", that.onMessage, false);
        }

        await this.mixinSiteConfigCheck();
        await this.mixinLoginCheck();
        this.isCheckedAdult = this.$store.state.isCheckedAdult;

        if(this.width_size <= 992){
            this.is_on_sideMenu = true;
        }

        window.scroll(0,0);
    },
    mounted(){
    },
    beforeDestroy() {
		window.removeEventListener('scroll',this.handleScroll);
        window.removeEventListener('mouseup', this.handleMouseUp);
	},
    methods: {
        handleScroll(){
			// if(this.width_size <= 414){
			// 	if (window.scrollY > 200) {
			// 		this.addClass("header", "navbar-opaque");
			// 	}else {
			// 		this.delClass("header", "navbar-opaque");
			// 	}
			// }else{

				if (window.scrollY > 1) {
                    this.addClass("pc_nav", "black");
                    
				}else {
                    this.delClass("pc_nav", "black");
				}
			// }
		},
        handleResize(){
            this.width_size = window.outerWidth;

            if(this.width_size > 992){
                if(this.is_show_sideMenu === true){
                    this.showMenu(false);
                }
            }
        },
        handleMouseUp(e){
            // var searchLayer = document.getElementById('search');
            var targetId = e.target.id;
            // console.log(e.target);
            if(targetId !== 'inputSearch' && targetId !== 'inputSearch2' && targetId !== 'btnSearch' && targetId !== 'btnSearch2' && targetId !== 'btnClear'){
                this.isOpenSearch = false;
                this.searchText = '';
                this.delClass("search-box", "open");
            }
        },
        toggleAdult(){
            // this.isCheckedAdult = !this.isCheckedAdult
            // console.log(1);
            if(this.$store.state.loginCheck === false){
                this.isShowLoginPopup = true;
            }else if(!this.$store.state.adult){
                // this.isShowAdultConfirmPopup = true;
                var src = this.siteConfig.niceUrl + '?email=' + this.$store.state.email;
                window.open(src, 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, location=no, scrollbar=no');
            }
            else{
                this.$store.commit("checkAdult", !this.isCheckedAdult);
                location.reload();
            }
            
        },
        toggleSearch(){
            // this.isOpenSearch = false;
            this.isOpenMypage = false;
            this.isOpenMetamask = false;
            this.isOpenKaikas = false;

            if(this.isOpenSearch === true){
                if(this.searchText.length > 0){
                    this.$router.push('/Category/0/' + this.searchText);
                }
            }               
            else{
                this.isOpenSearch = true;
                this.addClass("search-box", "open");
            }
        },
        toggleMypage(){
            this.isOpenSearch = false;
            this.isOpenMypage = false;
            this.isOpenMetamask = false;
            this.isOpenKaikas = false;

            if(this.isOpenMypage === true){
                this.isOpenMypage = false;
            }
            else{
                this.isOpenMypage = true
            }
        },
        closeMypage(){
            this.isOpenMypage = false;
        },
        toggleMetamask(){
            this.isOpenSearch = false;
            this.isOpenMypage = false;
            this.isOpenMetamask = false;
            this.isOpenKaikas = false;

            if(this.$store.state.isEnableMetamask === false || this.$store.state.erc20Address === null || this.$store.state.erc20Address === ''){
                this.isShowMetamaskPopup = true;
            }
            else if(this.$store.state.erc20Address !== null && this.$store.state.erc20Address !== '' && this.$store.state.erc20Address !== this.$store.state.account){
                this.initPopupOkMessage = '이미 연결된 지갑 주소와 MetaMask 지갑 주소가 다릅니다.<br/>MetaMask에서 활성화된 지갑을 확인해 주세요.';
                this.isShowPopupOkPopup = true;
            }
            else{
                if(this.isOpenMetamask === true){
                    this.isOpenMetamask = false;
                }
                else{
                    this.isOpenMetamask = true;
                }
            }
        },
        toggleKaikas(){
            this.isOpenSearch = false;
            this.isOpenMypage = false;
            this.isOpenMetamask = false;
            this.isOpenKaikas = false;

            if(this.$store.state.isEnableKaikas === false || this.$store.state.erc20Address === null || this.$store.state.erc20Address === ''){
                this.isShowKaikasPopup = true;
            }
            else if(this.$store.state.erc20Address !== null && this.$store.state.erc20Address !== '' && this.$store.state.erc20Address !== this.$store.state.account){
                this.initPopupOkMessage = '이미 연결된 지갑 주소와 Kaikas 지갑 주소가 다릅니다.<br/>Kaikas에서 활성화된 지갑을 확인해 주세요.';
                this.isShowPopupOkPopup = true;
            }
            else{
                if(this.isOpenKaikas === true){
                    this.isOpenKaikas = false;
                }
                else{
                    this.isOpenKaikas = true;
                }
            }
        },
        closeMetamask(){
            this.isOpenMetamask = false;
        },
        closeKaikas(){
            this.isOpenKaikas = false;
        },
        showLoginPopup(){
            this.isOpenSearch = false;
            this.isOpenMypage = false;
            this.isOpenMetamask = false;
            this.isOpenKaikas = false;
            this.isShowLoginPopup = false;

            if(this.$store.state.loginCheck === false){
                this.isShowLoginPopup = true;
            }
            else{
                this.initPopupOkMessage = '이미 로그인 상태 입니다.'
                this.isShowPopupOkPopup = true;
            }
            
        },
        showJeanGuidePopup(){
            this.isOpenSearch = false;
            this.isOpenMypage = false;
            this.isOpenMetamask = false;
            this.isOpenKaikas = false;
            this.isShowJeanguidePopup = true;
        },
        close(popupType){
            switch(popupType){
                case 'Login':
                    this.isShowLoginPopup = false;
                    break;
                case 'JeanGuide':
                    this.isShowJeanguidePopup = false;
                    break;
                case 'AdultConfirm':
                    this.isShowAdultConfirmPopup = false;
                    break;
                case 'Metamask':
                    this.isShowMetamaskPopup = false;
                    break;
                case 'Kaikas':
                    this.isShowKaikasPopup = false;
                    break;
                case 'PopupOk':
                    this.isShowPopupOkPopup = false;
                    if(this.PopupOkCallbakPage === 'reload'){
                        location.reload();
                    }
                    else if(this.PopupOkCallbakPage !== ''){
                        this.$router.push(this.PopupOkCallbakPage);
                    }
                    this.PopupOkCallbakPage = '';
                    break;
            }
        },
        logout(){
            this.$store.commit("logout");
            this.$router.push('/');
        },

        loginComplete(){
            this.isShowLoginPopup = false;
        },
        addClass(id, classe) {
            try{
                var element = document.getElementById(id);
                var classes = element.className.split(' ');
                var getIndex = classes.indexOf(classe);

                if (getIndex === -1) {
                    classes.push(classe);
                    element.className = classes.join(' ');
                }
            }catch(err){err;}
		},
		delClass(id, classe) {
            try{
                var element = document.getElementById(id);
                var classes = element.className.split(' ');
                var getIndex = classes.indexOf(classe);

                if (getIndex > -1) {
                    classes.splice(getIndex, 1);
                }
                element.className = classes.join(' ');
            }catch(err){err;}
		},
        showMenu(force) {
			if(this.is_show_sideMenu === true || force === false) {
				document.getElementById('toggle').setAttribute("class", "btn_nav");
				document.getElementById('toggle').style.margin = "10px 0";
				document.getElementById('m_mypage').style.display = "none";
                document.getElementById('pc_nav').style.padding = "13px 14px";
				document.getElementById('logo').setAttribute("class", "logo");
				document.getElementById('back').setAttribute("class", "back");
                    // document.getElementById('toggle-adult').setAttribute("class", "toggle-switch");
				document.getElementById('toggle-adult').setAttribute("class", "btn-adult");
				document.getElementById('artube-league').setAttribute("class", "artube-league");
				document.getElementById('search-box').setAttribute("class", "search-box");
				document.getElementById('nav_metamask').setAttribute("class", "metamask");
                    // document.getElementById('search').setAttribute("class", "search");
				this.is_show_overlay = false;
				this.is_show_sideMenu = false;
			}else if(this.is_show_sideMenu === false) {
				document.getElementById('toggle').setAttribute("class", "btn_nav_olive");
				document.getElementById('toggle').style.margin = "0 14px 0 0";
				document.getElementById('m_mypage').style.display = "block";
				document.getElementById('pc_nav').style.padding = "13px 0 0";
				document.getElementById('logo').setAttribute("class", "logo_noshow");
				document.getElementById('back').setAttribute("class", "back_noshow");
                    // document.getElementById('toggle-adult').setAttribute("class", "toggle-switch_noshow");
				document.getElementById('toggle-adult').setAttribute("class", "btn-adult_noshow");
				document.getElementById('artube-league').setAttribute("class", "artube-league_noshow");
				document.getElementById('search-box').setAttribute("class", "search-box_noshow");
				document.getElementById('nav_metamask').setAttribute("class", "metamask_noshow");
                    // document.getElementById('search').setAttribute("class", "search_noshow");
				this.is_show_overlay = true;
				this.is_show_sideMenu = true;
			}
		},

        searchOp(){
            if(this.isOpenSearch === true){
                document.getElementById('search').setAttribute('class','search op');
            }else if(this.isOpenSearch === false){
                document.getElementById('search').setAttribute('class','search');
            }
        },

        onMessage(event) {
            // Check sender origin to be trusted
            // if (event.origin !== "http://172.30.1.107:9094") return;
            var data = event.data;
            // console.log(event.data);

            if(data.func === "niceSuccess"){
                this.confirmNiceResult();
            }
            // if(data.func === "pnlinkSuccess"){
            //     console.log(' pnlinkSuccess ' );
            // }
            // if(data.func === "pnlinkFail"){
            //     console.log(' pnlinkFail ' );
            // }
        },
        confirmNiceResult(){ // 나이스 인증 확인
            var param = 
            {
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/adult/result`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                if (res.data.returnCode === 0) {
                    this.initPopupOkMessage = '본인 인증이 완료 되었습니다.'
                    this.PopupOkCallbakPage = 'reload';
                    this.isShowPopupOkPopup = true;
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        async getTokenInfo(){ // 토큰 정보
            var param = 
            {
            }
            try{
                await this.$Axios.post(`${this.host}/tokenInfo`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                    if (res.data.returnCode === 0) {
                        this.tokenInfo = res.data.data;
                    }
                })
                // .catch((error) => {
                //     console.log(error);
                // });
            }catch(err){
                return;
            }
            
        },
        clipboardSuccessHandler ({ value, event }) {
            value; event;
            this.isShowPopupOkPopup = true;
            this.initPopupOkMessage = '지갑 주소가 복사되었습니다.'
        },
    },
}
</script>